module.exports = __webpack_public_path__ + "static/media/Caelum.d3ddff78.svg";